import './Globals.scss';

import EventBus from 'appRoot/scripts/EventBus';

import { createApp } from 'vue';
import App from 'appRoot/vues/App.vue';
import CreateStore from 'appRoot/store/store';
import CreateRouter from 'appRoot/router/index';

import vsvg from 'appRoot/vues/common/controls/VSvg.vue';
import SvgButton from 'appRoot/vues/common/controls/SvgButton.vue';
import ScaleLoader from 'appRoot/vues/common/ScaleLoader.vue';

import 'vue3-toastify/dist/index.css';
import Vue3Toastify from 'vue3-toastify';

import VueGoodTablePlugin from 'vue-good-table-next'; // this is an enormous dependency, and could be removed in order to reduce bundle size
import 'vue-good-table-next/dist/vue-good-table-next.css'; // ^^

import VueDOMPurifyHTML from 'vue-dompurify-html';

import ToasterHelper from 'appRoot/scripts/ToasterHelper';

let store = window.store = CreateStore();

if (startupSession)
{
	store.commit("SessionAuthenticated", { sid: startupSession.sid, userData: startupSession.userData });
	startupSession = undefined;
}

let router = window.router = CreateRouter(store, appContext.appPath);

const app = createApp(App);

app.use(store);
app.use(router);

// Any recursively nested components must be globally registered here
app.component('vsvg', vsvg);
app.component('SvgButton', SvgButton);
app.component('ScaleLoader', ScaleLoader);

app.use(Vue3Toastify, {
	position: 'bottom-right', // matches the default position of the old @deveodk/vue-toastr
	closeOnClick: false,
	theme: 'colored'
});

app.use(VueGoodTablePlugin);

app.use(VueDOMPurifyHTML, {
	namedConfigurations: {
		plaintext: {
			USE_PROFILES: { html: false },
		},
	},
});

window.toaster = new ToasterHelper();

let uidCounter = 0;
window.GetUid = function ()
{
	return uidCounter++;
};

window.addEventListener('unhandledrejection', function (e)
{
	let msg = e.reason ? e.reason.toString() : JSON.stringify(e);
	try
	{
		toaster.error("Unhandled Promise Rejection", msg);
	}
	catch (ex)
	{
		console.error(ex);
		alert("Unhandled Promise Rejection: " + msg);
	}
});
app.config.errorHandler = function (err, vm, info)
{
	// `info` is a Vue-specific error info, e.g. which lifecycle hook
	// the error was found in.
	console.log("Vue errorHandler:");
	console.error(err, info, vm);
	if (typeof err.tdsErrorHandled === "undefined" || !err.tdsErrorHandled)
	{
		err.tdsErrorHandled = true;
		var errMsg = err;
		try
		{
			errMsg += '\r\n\r\nVue-specific error info: "' + info + '"';
		}
		catch (ex2)
		{
			errMsg += '\r\n\r\nVue-specific error info: [unable to read info object]';
		}
		try
		{
			errMsg += '\r\n\r\nComponent HTML: ' + vm.$el.innerHTML;
		}
		catch (ex2)
		{
			errMsg += '\r\n\r\nComponent HTML: [unable to read component html]';
		}
		try
		{
			toaster.error("Vue Error", errMsg);
		}
		catch (ex)
		{
			console.error(ex);
			alert("Vue Error: " + errMsg);
		}
	}
};

router.isReady().then(() =>
{
	const matchedComponents = router.currentRoute.value.matched;

	if (matchedComponents.length < 1)
		window.location.replace(appContext.appPath + "404.html");

	window.myApp = app.mount('#app');
});
